import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import SEOHead from "@/components/SEOHead";

export default function PageBanner({ pageKey, seoKey, eyebrow, title, titleTestId }) {
  const [bgImage, setBgImage] = useState("");

  useEffect(() => {
    api.get("/site-settings").then((res) => setBgImage(res.data.page_backgrounds?.[pageKey] || "")).catch(() => {});
  }, [pageKey]);

  if (bgImage) {
    return (
      <>
        <SEOHead pageKey={seoKey || pageKey} />
        <div data-testid={`page-banner-${pageKey}`} className="relative h-[16vh] sm:h-[32vh] lg:h-[36vh] min-h-[130px] sm:min-h-[260px] lg:min-h-[300px] flex items-center justify-center text-center bg-cover bg-center" style={{ backgroundImage: `url(${bgImage})` }}>
          <div className="absolute inset-0 bg-[#1A1A1A]/60" />
          <div className="relative z-10 px-4">
            <span className="text-xs tracking-[0.2em] uppercase font-bold text-[var(--brand-primary)]">{eyebrow}</span>
            <h1 data-testid={titleTestId} className="font-heading text-4xl sm:text-4xl text-white mt-2 sm:mt-3">{title}</h1>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <SEOHead pageKey={seoKey || pageKey} />
      <div data-testid={`page-banner-${pageKey}`} className="text-center mb-10 sm:mb-14">
        <span className="text-xs tracking-[0.2em] uppercase font-bold text-[var(--brand-primary)]">{eyebrow}</span>
        <h1 data-testid={titleTestId} className="font-heading text-4xl sm:text-4xl text-[#1A1A1A] mt-3">{title}</h1>
      </div>
    </>
  );
}
